import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { nodeEmitter } from '../../services/flowBuilder/utils/locaction-calculator-interface';
import { ActiveFormService } from '../../services/active-form.service';
import { DeleteStepData } from '../../services/flowBuilder/models';
import { SharedService } from '../../../../core/services/store/shared-store/shared-storage.service';
import {selectFlowModeState} from '../../../../core/state/selectors/flow.selector';
import {Store} from '@ngrx/store';
import {FlowModeState} from '../../../../shared/models/state/Flow';
import {Observable, Subscription} from 'rxjs';

export type SideBarDisplay = 'NEW' | 'EDIT';

const leftSidebarMinimumWidth = 190;
const rightSidebarMinimumWidth = 360;
let rightSidebarWidth = 0;
let rightSidebarOffsetLeft = 0;
let rightSidebar: HTMLDivElement;
let showVariables: boolean = false;

@Component({
  selector: 'right-sidebar',
  templateUrl: './right-sidebar.component.html',
  styleUrls: ['./right-sidebar.component.scss'],
})
export class RightSidebarComponent implements OnInit, OnDestroy, OnChanges {
  // tslint:disable-next-line:no-input-rename
  @Input('sideBarDisplay') right_sidebar_display: string;
  @Input() data: nodeEmitter;
  @Input() isRecycle: nodeEmitter;
  @Input() displayMode: string;
  @Input() currentFlowSteps: string[];

  @Output() saveNode = new EventEmitter<Object>();
  @Output() deleteNode = new EventEmitter<DeleteStepData>();
  @Output() resetNode = new EventEmitter();
  @Output() updateFlow = new EventEmitter<String>();

  flowState$: Observable<FlowModeState>;
  flowStateSubscription: Subscription;
  deli: boolean = false;

  constructor(
    public sharedService: SharedService,
    public activeFormService: ActiveFormService,
    private store: Store,
    ) {}

  ngOnInit() {
    this.flowState$ = this.store.select(selectFlowModeState)
  }

  ngOnDestroy(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // JF - need to find a way to reload a component for now This seems to work
    // look into https://angular.io/guide/dynamic-component-loader
    if(changes.data) {
      this.deli = false
      setTimeout(() => this.deli = true, 1)
    }
  }

  dragBarMouseDown(event: MouseEvent) {
    //event.preventDefault();
    let dragBar: HTMLDivElement = <HTMLDivElement>event.target;
    rightSidebar = <HTMLDivElement>dragBar.parentElement;
    rightSidebarWidth = rightSidebar.clientWidth;
    rightSidebarOffsetLeft = rightSidebar.offsetLeft;

    document.body.style.cursor = 'col-resize';

    let rightSidebarResize = function (event: MouseEvent) {
      event.preventDefault();
      let x = event.pageX - rightSidebarOffsetLeft;
      let newWidth = window.innerWidth - event.pageX - -2;
      if (
        newWidth > rightSidebarMinimumWidth &&
        newWidth < window.innerWidth - leftSidebarMinimumWidth
      ) {
        rightSidebar.style.width = newWidth + 'px';
      }
    };

    document.addEventListener('mousemove', rightSidebarResize);

    document.addEventListener('mouseup', function () {
      document.removeEventListener('mousemove', rightSidebarResize, false);
      document.body.style.cursor = '';
    });
  }

  saveNodeClicked(event: Object) {
    this.saveNode.emit(event);
    this.sharedService.setIsFlowChanged(true);
  }

  deleteNodeClicked(deleteStep: DeleteStepData) {
    this.deleteNode.emit(deleteStep);
    this.sharedService.setIsFlowChanged(true);
  }

  updateFlowHandler(flowName) {
    this.updateFlow.emit(flowName);
  }
}
